
class TokenManagerClass {

    setToken(value: string) {
        const date = new Date();
                                    // 30 = le nombre de jours avant expiration
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        
        document.cookie = "token=" + value + ";" + expires + ";path=/";
    }


    getToken() {
        const cookies = document.cookie.split(";");
        
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            
            if (cookie.startsWith("token=")) {
                return cookie.substring("token".length + 1);
            }
        }
        
        return "";
    }

    deleteToken() {
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
}

export const TokenManager = new TokenManagerClass();
